<template>
    <button @click="reset()" type="button" :class="{'btn-success': enable, 'btn-danger': ! enable, }"
            class="btn btn-sm btn-block">
        {{text}}
    </button>
</template>
<script>
import {Comandos, Concox} from '../../class';
    import {Bus} from '../../class/bus';
    export default {
        name: "HabilitarIgnVirtual",
        props: {
            text: {
                default: "SZCS#ACCLINE=X"
            },
            id_rastreador: {
                "default": null
            },
            enable: {
                default: true
            }
        },
        methods: {
            async reset () {
                await Comandos.ignVirtual(this.id_rastreador, this.enable);
                Bus.$emit('comandos');
            }
        }
    }
</script>
